
import { AppModule } from '@/store/modules/app'
import { Component, Watch, Vue } from 'vue-property-decorator'
import Player from 'xgplayer'
import 'xgplayer/dist/index.min.css'

@Component
export default class VideoPlayer extends Vue {
  player: any = null

  get url () {
    return AppModule.url
  }

  beforeDestroy() {
    this.player && this.player.destroy()
  }

  @Watch('url')
  onUrlChange (val: null | string) {
    if (val) {
      if (this.player) {
        this.player.src = val
      } else {
        this.player = new Player({
          'lang': 'zh',
          'id': 'video_player',
          'url': val,
          'playsinline': true,
          'x5-video-player-type': 'h5',
          'x5-video-player-fullscreen': 'true',
          'x5-video-orientation': 'portraint',
          'autoplay': true,
          'width': 600,
          'height': 337
        })
      }
    } else {
      this.player.pause()
      this.player.url = null
    }
  }

  onClick() {
    AppModule.closeVideo()
  }
}
